<template>
    <div class="my-goals-edit-modal">

        <!-- edit button -->
        <b-btn size="sm" class="btn-edit btn-icon" variant="default"
               @click.stop="showModal()">
            <shs-icon :name="goal ? 'pencil' : 'plus'"></shs-icon>
        </b-btn>

        <!-- modal -->
        <data-form-modal :modal-id="modalId"
                         :title="$i18n.gt('LABEL_EDIT_GOAL')"
                         :save-button-label="$i18n.gt('LABEL_SAVE')"
                         :field-model="goalFields"
                         :field-groups="fieldGroups"
                         :model-instance="editingGoal"
                         :on-cancel-handler="cancelModal"
                         :on-submit-handler="saveParticipant">

            <!-- additional content for modal -->
            <template v-slot:modal-footer-extra>
                <b-btn class="btn-delete"
                       @click="deleteGoal()">
                    {{ $i18n.gt('LABEL_DELETE_GOAL') }}
                    <shs-icon name="delete"></shs-icon>
                </b-btn>
            </template>

        </data-form-modal>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import GoalFields from '@/models/Goal'

/**
 * Button and modal to edit an individual wellness Goal
 */

export default Vue.extend({
    name: 'MyGoalsEditModal',
    props: {
        goals: Array,
        // both empty if adding a new goal
        goal: Object,
        index: {type: Number, default: -1}
    },
    data() {
        return {
            editingGoal: this.getEditingGoal(),
            goalFields: GoalFields,
            fieldGroups: [['goal', 'timeframe']],
        }
    },
    computed: {
        modalId() {
            return `goalModal_${this.index}`
        }
    },
    methods: {
        getEditingGoal() {
            if (this.goal) {
                return this.goal
            } else {
                return {timeframe: null, goal: ''}
            }
        },
        showModal() {
            this.editingGoal = this.getEditingGoal()
            if (!this.goal) {
                this.goals.push(this.editingGoal) // creating a new goal
            }
            this.$bvModal.show(this.modalId)
        },
        cancelModal() {
            if (!this.goal) {
                this.$delete(this.goals, this.goals.length - 1) // remove added goal
            }
        },
        deleteGoal() {
            this.$bvModal.msgBoxConfirm(this.$i18n.gt('MESSAGE_DELETE_GOAL'))
                .then((value) => {
                    if (value) {
                        this.$delete(this.goals, this.goals.indexOf(this.goal))
                        this.$bvModal.hide(this.modalId)
                        this.saveParticipant()
                    }
                })
        },
        saveParticipant() {
            this.$store.dispatch('savePatientParticipant')
                .then(() => {
                    // reset modal in case we want to create another goal
                    this.editingGoal = this.getEditingGoal()
                })
        }
    },
})
</script>
